// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"9286e59a","488":"003f550b"}[chunkId] + ".chunk.js";
};